// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- GLOBAL PAGE SETUP --- */
.products-page {
    position: relative;
    width: 100%;
    height: auto;
    background: #f2eee6;
   
}

.products-page .products {
    width: 100%;
    height: auto;
    display: flex;
  background: #f2eee6;
    flex-direction: column;
}

.products-page .products .product-catalog-hero {
    position: relative;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
    overflow: hidden;
    background: #05090d;
    border-bottom: 1px solid rgba(184, 138, 68, 0.18);
}

.products-page .products .catalog-hero-main {
    position: relative;
    width: min(100%, 1500px);
    aspect-ratio: 1440 / 590;
    margin-inline: auto;
    overflow: hidden;
}

.products-page .products .catalog-hero-main::after {
    position: absolute;
    inset: 0;
    z-index: 1;
    content: "";
    pointer-events: none;
    background: linear-gradient(90deg, rgba(5, 9, 13, .68) 0%, rgba(5, 9, 13, .18) 46%, transparent 68%);
}

.products-page .products .catalog-hero-content-container {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 1500px;
    height: 100%;
    margin: 0 auto;
    padding-inline: 64px;
    box-sizing: border-box;
}

.products-page .products .catalog-hero-layout {
    width: 100%;
    height: 100%;
    margin: 0;
    display: grid;
    grid-template-columns: minmax(0, 560px) minmax(0, 1fr);
    align-items: center;
}

/* --- HEADER / TOP TEXT --- */
.products-page .products .top-text {
    width: 100%;
    max-width: 560px;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}

.products-page .products .top-text p {
    margin: 0;
    font-family: "Playfair Display", serif;
    font-weight: 400;
    font-size: clamp(48px, 4vw, 56px);
    line-height: 0.98;
    letter-spacing: 0.025em;
    color: #f4f1ea;
    text-transform: uppercase;
    text-align: left;
}

.products-page .products .catalog-title-accent {
    width: 44px;
    height: 1px;
    margin-top: 17px;
    background: #b88a44;
}

.products-page .products .catalog-subtitle {
    max-width: 430px;
    margin-top: 16px;
    color: rgba(244, 241, 234, 0.72);
    font: 400 14px/1.6 "Poppins", sans-serif;
    letter-spacing: 0.035em;
    text-align: left;
}

.products-page .products .catalog-hero-media {
    position: absolute;
    inset: 0;
    z-index: 0;
    overflow: hidden;
}

.products-page .products .catalog-hero-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: right 44%;
    border: 0;
    margin: 0;
    box-sizing: border-box;
}
.products-page .products .catalog-hero-controls {
    width: 100%;
    max-width: 1280px;
    margin: 36px 0 0;
    padding: 22px 40px 24px;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    justify-content: center;
    column-gap: 16px;
    background: #e8e1d7;
    border-bottom: 1px solid rgba(16, 32, 43, 0.1);
    box-sizing: border-box;
}

/* --- CENTRALIZED LUXURY CONTROL CENTER --- */
.single-search-form {
    grid-column: 1 / -1;
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    width: min(820px, 100%) !important;
    height: 48px;
    gap: 0 !important;
    margin: 0 auto !important;
    overflow: hidden;
    border: 1px solid rgba(184, 138, 68, 0.28);
    border-radius: 6px;
    background: #0d1e2b;
    box-shadow: 0 8px 22px rgba(5, 9, 13, 0.1);
}

.single-search-input {
    min-width: 0;
    height: 100%;
    flex: 1 1 !important;
    padding: 0 18px !important;
    border: 0 !important;
    outline: 0;
    background: transparent;
    color: #f4f1ea;
    font: 400 12px/1 "Poppins", sans-serif;
    letter-spacing: 0.04em;
}

.single-search-input::placeholder {
    color: rgba(244, 241, 234, 0.45);
}

.products-page .products .single-button-search.MuiButton-root {
    min-width: 126px;
    height: 100%;
    padding: 0 20px !important;
    border: 0 !important;
    border-left: 1px solid rgba(184, 138, 68, 0.38) !important;
    border-radius: 0 !important;
    background: #b88a44 !important;
    color: #05090d !important;
    box-shadow: none;
    font: 600 10px/1 "Poppins", sans-serif;
    letter-spacing: 0.14em;
    transition: background-color 220ms ease;
}

.products-page .products .single-button-search.MuiButton-root:hover {
    background: #c39955 !important;
    box-shadow: none;
}

.products-page .products .products-filter-section {
    margin-top: 10px;
}

.products-filter-box {
    display: flex !important;
    flex-direction: row !important;
    width: auto !important;
    gap: 0 !important;
    margin: 0 !important;
    overflow: hidden;
    border: 1px solid rgba(16, 32, 43, 0.2);
    border-radius: 3px;
}

.products-page .products .order.MuiButton-root {
    min-width: 88px;
    height: 30px;
    padding: 0 15px !important;
    border: 0 !important;
    border-right: 1px solid rgba(16, 32, 43, 0.14) !important;
    border-radius: 0 !important;
    background: transparent !important;
    color: #10202b !important;
    box-shadow: none;
    font: 500 9px/1 "Poppins", sans-serif;
    letter-spacing: 0.14em;
}

.products-page .products .order.MuiButton-root:last-child {
    border-right: 0 !important;
}

.products-page .products .order.MuiButton-containedPrimary {
    background: rgba(184, 138, 68, 0.16) !important;
    color: #b88a44 !important;
}

/* --- FILTERS / CATEGORY NAV --- */
.products-page .products .product-category {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    padding-left: 0;
}

.products-page .products .category-main {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    justify-content: center;
}

.products-page .products .category-main .MuiButton-root {
    min-width: 0;
    height: 30px;
    padding: 0 15px;
    border: 1px solid rgba(16, 32, 43, 0.18);
    border-radius: 999px;
    background: transparent;
    color: #10202b;
    box-shadow: none;
    font: 500 9px/1 "Poppins", sans-serif;
    letter-spacing: 0.1em;
}

.products-page .products .category-main .MuiButton-containedPrimary {
    border-color: #b88a44;
    background: #b88a44;
    color: #05090d;
}

.products-page .products .category-main .MuiButton-root:hover {
    border-color: rgba(184, 138, 68, 0.75);
    background: rgba(184, 138, 68, 0.12);
    box-shadow: none;
}

@media (max-width: 1100px) {
    .products-page .products .catalog-hero-content-container { padding-inline: 32px; }
    .products-page .products .top-text { max-width: 480px; }
}
@media (max-width: 900px) {

    .products-page .products .category-main { flex-wrap: wrap; }
}

@media (max-width: 760px) {
    .products-page .products .catalog-hero-content-container { padding-inline: 16px; }
    .products-page .products .top-text { max-width: 360px; }
}
@media (max-width: 600px) {

    .products-page .products .top-text p { font-size: 40px; }

    .products-page .products .catalog-subtitle {
        max-width: 310px;
        font-size: 11px;
    }

    .products-page .products .single-button-search.MuiButton-root {
        min-width: 104px;
        padding-inline: 14px !important;
    }
}.sub-category-list {
    position: absolute;
    left: calc(50% + 150px);
    top: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
    animation: fadeInRight 0.5s ease;
}

.sub-category-list button {
    background: none !important;
    border: none !important;
    font-family: 'Playfair Display', serif;
    font-size: 18px;
    color: #777 !important;
    cursor: pointer;
    text-align: left;
    padding: 0;
}
/* --- PRODUCT CARD & WRAPPER --- */
/* --- PRODUCT CARD & WRAPPER --- */
.products-page .products .product-wrapper {
    margin-left: 25px;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center; /* Centers the cards */
}

.products-page .products .product-card {
    margin: 34px 20px;
    width: 270px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    background: #0d1e2b;
    padding-bottom: 14px;
    border: 1px solid rgba(184, 138, 68, 0.2);
    border-radius: 8px;
    box-shadow: 0 12px 28px rgba(5, 9, 13, 0.12);
    transition: transform 260ms ease, border-color 260ms ease, box-shadow 260ms ease;
}

.products-page .products .product-card:hover {
    transform: translateY(-4px);
    border-color: rgba(184, 138, 68, 0.42);
    box-shadow: 0 16px 34px rgba(5, 9, 13, 0.18);
}

.products-page .products .product-card .product-img {
    position: relative;
    width: 273px;
    height: 275px;
    background-size: cover;
    background-position: center;
    /* Luxury Shape: Sharp top, soft bottom curve */
    border-radius: 8px 8px 0 0;
}

.products-page .products .product-card .product-img .product-sale {
    position: absolute;
    margin: 15px;
    z-index: 100;
    width: auto;
    min-width: 54px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* Luxury Tag: Champagne Gold with dark text */
    background: rgba(13, 30, 43, 0.82);
    box-shadow: none;
    border-radius: 3px;
    font-family: "Poppins", sans-serif;
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    color: #b88a44; /* Dark blue/black text */
}

.products-page .products .product-img:before {
    border-radius: 8px 8px 0 0;
    content: "";
    opacity: 0;
    transition: opacity 0.5s ease;
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 2;
}

.products-page .products .product-img:hover:before {
    opacity: 1;
}

/* --- HOVER BUTTONS --- */
.products-page .products .shop-btn {
    position: absolute;
    top: 217px; left: 105px;
    width: 64px; height: 46px;
    z-index: 3;
    opacity: 0;
    transition: opacity 0.5s ease;
    background: rgba(13, 30, 43, 0.88) !important;
    border: 2px solid #d7b686 !important;
    border-radius: 10px !important;
}

.products-page .products .view-btn {
    position: absolute;
    top: 223px; right: 36px;
    width: 40px; height: 40px;
    z-index: 3;
    opacity: 0;
    transition: opacity 0.5s ease;
}

.products-page .products .product-img:hover .shop-btn,
.products-page .products .product-img:hover .view-btn {
    opacity: 1;
}

/* --- PRODUCT DESCRIPTION --- */
.products-page .products .product-card .product-desc {
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.products-page .products .product-desc .product-title {
    margin-top: 12px;
    font-family: "Playfair Display", serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 1.2;
    color: #f4f1ea;
    letter-spacing: 0.025em;
    text-transform: capitalize;
    transition: color 260ms ease;
}

/* Hover state adds a premium "Luxury Gold" glow */
.products-page .products .product-card:hover .product-title {
    color: #b88a44;
}
.products-page .products .product-desc .product-desc {
    margin-top: 5px;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 1;
    color: #b88a44;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
}

.products-page .products .product-desc .product-desc .MuiSvgIcon-root {
    width: 15px;
    height: 15px;
    opacity: 0.72;
}

/* --- BRANDS & ADDRESS --- */
/* --- BRANDS SECTION CSS --- */
/* Container Style */
.brands-logo {
  width: 100%;
  background: #e8e1d7;
  padding: 80px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.brands-logo .brands-title {
  font-family: "Poppins", sans-serif;
  font-size: 36px;
  font-weight: 600;
  color: #10202b;
  margin-bottom: 40px;
  text-align: center;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px; /* More space between stands */
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

.video-box {
  width: 100%;
  aspect-ratio: 3 / 4; /* Keeps them as "Luxury Stands" */
  overflow: hidden;
  border-radius: 20px 20px 50px 50px;
  border: 2px solid #d7b586;
  background: #1a1e22;
}
  
.video-box video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 15px 15px 40px 40px; /* Matches container shape */
}

.video-box:hover {
  transform: translateY(-10px); /* Lift effect */
  box-shadow: 0 20px 40px rgba(215, 181, 134, 0.3);
}

.video-box video {
  width: 100%;.video-box video {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures video stays inside the box */
}
  height: 100%;
  object-fit: cover;
  border-radius: 15px 15px 40px 40px; /* Matches the container shape */
}
/* Responsive Grid for Tablets/Phones */

@media (max-width: 900px) {
  .video-grid { grid-template-columns: repeat(2, 1fr); }
}


@media (max-width: 600px) {
  .video-grid { grid-template-columns: 1fr; }
}

/* Restored Hover Logic */
/* --- BRANDS SECTION CSS --- */
.brands-logo .brand-card {
  width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  /* Added your border and radius here */
  border: 1px solid #d9d9d9;
  border-radius: 10px; 
  /* ------------------------------- */
  transition: all 0.4s ease; 
  cursor: pointer;
}

.brands-logo .brand-card:hover {
  transform: translateY(-5px); 
  box-shadow: 0px 10px 25px rgba(215, 181, 134, 0.2); 
  background: rgba(255, 255, 255, 0.03);
  /* Optional: Change border color on hover to match the glow */
  border-color: #d7b586; 
}

.brands-logo .brand-card img {
  width: 100%;
  height: auto;
  object-fit: contain;
}
/* --- CHOSEN PRODUCT --- */
.products-page .chosen-product {
    position: relative;
    width: 100%;
    height: auto;
    background: #f2eee6;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.products-page .chosen-product .product-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 80px;
    margin-bottom: 150px;
}

.products-page .chosen-product .chosen-product-slider {
    width: 48%;
    height: 480px;
    background: #ffffff;
    box-shadow: 9px 13px 14px 5px rgba(0, 0, 0, 0.25), inset -1px 2px 10px 3px rgba(0, 0, 0, 0.25);
    border-radius: 16px;
    overflow: hidden;
}

.products-page .chosen-product .chosen-product-slider .swiper-area {
    --swiper-navigation-color: #fff;
    --swiper-pagination-color: #fff;
    width: 100%;
    height: 1020px;
}

.products-page .chosen-product .chosen-product-slider .swiper-area .slider-image {
    width: 100%;
    height: 100%;
}

.products-page .chosen-product .chosen-product-info {
    padding: 30px 40px;
    width: 49%;
    height: 480px;
    display: flex;
    background: #ffffff;
    box-shadow: 9px 13px 14px 5px rgba(0, 0, 0, 0.25), inset -1px 2px 10px 3px rgba(0, 0, 0, 0.25);
    border-radius: 16px;
}

.products-page .chosen-product .chosen-product-info .info-box {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
}

.products-page .chosen-product .info-box .product-name {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 36px;
    color: #000000;
}

.products-page .chosen-product .info-box .stock-count {
    margin-top: 16px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 15px;
    color: #979797;
}

.products-page .chosen-product .info-box .rating-box {
    margin-top: 20px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.products-page .chosen-product .rating-box .star-box {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.products-page .chosen-product .rating-box .evaluation-box {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.products-page .chosen-product .rating-box .evaluation-box .product-view {
    display: flex;
    align-items: center;
}

.products-page .chosen-product .info-box .product-desc {
    height: 112px;
    margin-top: 30px;
    margin-bottom: 30px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #000000;
}

.products-page .chosen-product .info-box .product-price {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.products-page .chosen-product .product-price span {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 25px;
    line-height: 22px;
    color: #000000;
}

.products-page .chosen-product .button-box {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.products-page .chosen-product .button-box button {
    width: 230px;
    height: 44px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 22px;
    color: #f8f8ff;
}

.products-page .chosen-product .title {
    font-family: "Dancing Script";
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    margin-top: 40px;
}

.address {
  width: 100%;
  padding: 80px 0;
  background-color: #f2eee6;
  display: flex;
  justify-content: center;
}

.address-area {
  width: 100%;
  align-items: center;
}

.address-area .title {
  font-family: "Poppins", sans-serif;
  font-size: 36px;
  font-weight: 600;
  color: #10202b;
  text-align: center;
  margin-bottom: 20px;
}

/* Luxury Map Wrapper */
.map-luxury-wrapper {
  width: 100%;
  max-width: 1100px; /* Wider for better visibility */
  height: 500px;     /* Set a clear, tall height */
  margin: 40px auto;
  border: 3px solid #d7b586; /* Gold border */
  border-radius: 20px;
  padding: 5px;
  background: #1a1e22;
  box-shadow: 0 15px 40px rgba(0,0,0,0.7);
  overflow: hidden;
}

.map-luxury-wrapper iframe {
  width: 100%;
  height: 100%;
  border-radius: 15px;
  /* Dark mode filter to match your theme */
  filter: grayscale(0.5) invert(0.9) contrast(1.2);
}`, "",{"version":3,"sources":["webpack://./src/css/products.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;EACf,mBAAmB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,oGAAoG;AACxG;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,aAAa;IACb,sDAAsD;IACtD,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,sCAAsC;IACtC,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,wCAAwC;IACxC,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,SAAS;IACT,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,8CAA8C;IAC9C,sBAAsB;AAC1B;;AAEA,8CAA8C;AAC9C;IACI,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,8BAA8B;IAC9B,kCAAkC;IAClC,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;IACpB,UAAU;IACV,uBAAuB;IACvB,cAAc;IACd,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,oBAAoB;IACpB,0DAA0D;IAC1D,2BAA2B;IAC3B,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;IAChB,sCAAsC;IACtC,sBAAsB;IACtB,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,0BAA0B;IAC1B,oBAAoB;IACpB,yDAAyD;IACzD,2BAA2B;IAC3B,kCAAkC;IAClC,yBAAyB;IACzB,gBAAgB;IAChB,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,wCAAwC;IACxC,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,2DAA2D,oBAAoB,EAAE;IACjF,qCAAqC,gBAAgB,EAAE;AAC3D;AACA;;IAEI,0CAA0C,eAAe,EAAE;AAC/D;;AAEA;IACI,2DAA2D,oBAAoB,EAAE;IACjF,qCAAqC,gBAAgB,EAAE;AAC3D;AACA;;IAEI,uCAAuC,eAAe,EAAE;;IAExD;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,+BAA+B;IACnC;AACJ,CAAC;IACG,kBAAkB;IAClB,uBAAuB;IACvB,MAAM;IACN,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,sCAAsC;IACtC,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;AACA,mCAAmC;AACnC,mCAAmC;AACnC;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB,EAAE,sBAAsB;AACnD;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,yCAAyC;IACzC,kBAAkB;IAClB,4CAA4C;IAC5C,gFAAgF;AACpF;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;IACtC,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,+CAA+C;IAC/C,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8CAA8C;IAC9C,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,cAAc,EAAE,yBAAyB;AAC7C;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,UAAU;IACV,6BAA6B;IAC7B,kBAAkB;IAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;IACpC,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,UAAU,EAAE,WAAW;IACvB,WAAW,EAAE,YAAY;IACzB,UAAU;IACV,UAAU;IACV,6BAA6B;IAC7B,6CAA6C;IAC7C,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,UAAU,EAAE,WAAW;IACvB,WAAW,EAAE,YAAY;IACzB,UAAU;IACV,UAAU;IACV,6BAA6B;AACjC;;AAEA;;IAEI,UAAU;AACd;;AAEA,gCAAgC;AAChC;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA,kDAAkD;AAClD;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA,6BAA6B;AAC7B,+BAA+B;AAC/B,oBAAoB;AACpB;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS,EAAE,8BAA8B;EACzC,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,kCAAkC;EACvD,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kCAAkC,EAAE,4BAA4B;AAClE;;AAEA;EACE,4BAA4B,EAAE,gBAAgB;EAC9C,gDAAgD;AAClD;;AAEA;EACE,WAAW,CAAC;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,uCAAuC;AAC5D;EACE,YAAY;EACZ,iBAAiB;EACjB,kCAAkC,EAAE,gCAAgC;AACtE;AACA,uCAAuC;;AAEvC;EACE,cAAc,qCAAqC,EAAE;AACvD;;;AAGA;EACE,cAAc,0BAA0B,EAAE;AAC5C;;AAEA,yBAAyB;AACzB,+BAA+B;AAC/B;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;EAClD,qCAAqC;EACrC,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8FAA8F;IAC9F,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8FAA8F;IAC9F,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,iBAAiB,EAAE,gCAAgC;EACnD,aAAa,MAAM,6BAA6B;EAChD,iBAAiB;EACjB,yBAAyB,EAAE,gBAAgB;EAC3C,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,gDAAgD;AAClD","sourcesContent":["/* --- GLOBAL PAGE SETUP --- */\n.products-page {\n    position: relative;\n    width: 100%;\n    height: auto;\n    background: #f2eee6;\n   \n}\n\n.products-page .products {\n    width: 100%;\n    height: auto;\n    display: flex;\n  background: #f2eee6;\n    flex-direction: column;\n}\n\n.products-page .products .product-catalog-hero {\n    position: relative;\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    overflow: hidden;\n    background: #05090d;\n    border-bottom: 1px solid rgba(184, 138, 68, 0.18);\n}\n\n.products-page .products .catalog-hero-main {\n    position: relative;\n    width: min(100%, 1500px);\n    aspect-ratio: 1440 / 590;\n    margin-inline: auto;\n    overflow: hidden;\n}\n\n.products-page .products .catalog-hero-main::after {\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    content: \"\";\n    pointer-events: none;\n    background: linear-gradient(90deg, rgba(5, 9, 13, .68) 0%, rgba(5, 9, 13, .18) 46%, transparent 68%);\n}\n\n.products-page .products .catalog-hero-content-container {\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    max-width: 1500px;\n    height: 100%;\n    margin: 0 auto;\n    padding-inline: 64px;\n    box-sizing: border-box;\n}\n\n.products-page .products .catalog-hero-layout {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    display: grid;\n    grid-template-columns: minmax(0, 560px) minmax(0, 1fr);\n    align-items: center;\n}\n\n/* --- HEADER / TOP TEXT --- */\n.products-page .products .top-text {\n    width: 100%;\n    max-width: 560px;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n.products-page .products .top-text p {\n    margin: 0;\n    font-family: \"Playfair Display\", serif;\n    font-weight: 400;\n    font-size: clamp(48px, 4vw, 56px);\n    line-height: 0.98;\n    letter-spacing: 0.025em;\n    color: #f4f1ea;\n    text-transform: uppercase;\n    text-align: left;\n}\n\n.products-page .products .catalog-title-accent {\n    width: 44px;\n    height: 1px;\n    margin-top: 17px;\n    background: #b88a44;\n}\n\n.products-page .products .catalog-subtitle {\n    max-width: 430px;\n    margin-top: 16px;\n    color: rgba(244, 241, 234, 0.72);\n    font: 400 14px/1.6 \"Poppins\", sans-serif;\n    letter-spacing: 0.035em;\n    text-align: left;\n}\n\n.products-page .products .catalog-hero-media {\n    position: absolute;\n    inset: 0;\n    z-index: 0;\n    overflow: hidden;\n}\n\n.products-page .products .catalog-hero-image {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: right 44%;\n    border: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n.products-page .products .catalog-hero-controls {\n    width: 100%;\n    max-width: 1280px;\n    margin: 36px 0 0;\n    padding: 22px 40px 24px;\n    display: grid;\n    grid-template-columns: auto 1fr;\n    align-items: center;\n    justify-content: center;\n    column-gap: 16px;\n    background: #e8e1d7;\n    border-bottom: 1px solid rgba(16, 32, 43, 0.1);\n    box-sizing: border-box;\n}\n\n/* --- CENTRALIZED LUXURY CONTROL CENTER --- */\n.single-search-form {\n    grid-column: 1 / -1;\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: center !important;\n    width: min(820px, 100%) !important;\n    height: 48px;\n    gap: 0 !important;\n    margin: 0 auto !important;\n    overflow: hidden;\n    border: 1px solid rgba(184, 138, 68, 0.28);\n    border-radius: 6px;\n    background: #0d1e2b;\n    box-shadow: 0 8px 22px rgba(5, 9, 13, 0.1);\n}\n\n.single-search-input {\n    min-width: 0;\n    height: 100%;\n    flex: 1 !important;\n    padding: 0 18px !important;\n    border: 0 !important;\n    outline: 0;\n    background: transparent;\n    color: #f4f1ea;\n    font: 400 12px/1 \"Poppins\", sans-serif;\n    letter-spacing: 0.04em;\n}\n\n.single-search-input::placeholder {\n    color: rgba(244, 241, 234, 0.45);\n}\n\n.products-page .products .single-button-search.MuiButton-root {\n    min-width: 126px;\n    height: 100%;\n    padding: 0 20px !important;\n    border: 0 !important;\n    border-left: 1px solid rgba(184, 138, 68, 0.38) !important;\n    border-radius: 0 !important;\n    background: #b88a44 !important;\n    color: #05090d !important;\n    box-shadow: none;\n    font: 600 10px/1 \"Poppins\", sans-serif;\n    letter-spacing: 0.14em;\n    transition: background-color 220ms ease;\n}\n\n.products-page .products .single-button-search.MuiButton-root:hover {\n    background: #c39955 !important;\n    box-shadow: none;\n}\n\n.products-page .products .products-filter-section {\n    margin-top: 10px;\n}\n\n.products-filter-box {\n    display: flex !important;\n    flex-direction: row !important;\n    width: auto !important;\n    gap: 0 !important;\n    margin: 0 !important;\n    overflow: hidden;\n    border: 1px solid rgba(16, 32, 43, 0.2);\n    border-radius: 3px;\n}\n\n.products-page .products .order.MuiButton-root {\n    min-width: 88px;\n    height: 30px;\n    padding: 0 15px !important;\n    border: 0 !important;\n    border-right: 1px solid rgba(16, 32, 43, 0.14) !important;\n    border-radius: 0 !important;\n    background: transparent !important;\n    color: #10202b !important;\n    box-shadow: none;\n    font: 500 9px/1 \"Poppins\", sans-serif;\n    letter-spacing: 0.14em;\n}\n\n.products-page .products .order.MuiButton-root:last-child {\n    border-right: 0 !important;\n}\n\n.products-page .products .order.MuiButton-containedPrimary {\n    background: rgba(184, 138, 68, 0.16) !important;\n    color: #b88a44 !important;\n}\n\n/* --- FILTERS / CATEGORY NAV --- */\n.products-page .products .product-category {\n    margin-top: 10px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    padding-left: 0;\n}\n\n.products-page .products .category-main {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    justify-content: center;\n}\n\n.products-page .products .category-main .MuiButton-root {\n    min-width: 0;\n    height: 30px;\n    padding: 0 15px;\n    border: 1px solid rgba(16, 32, 43, 0.18);\n    border-radius: 999px;\n    background: transparent;\n    color: #10202b;\n    box-shadow: none;\n    font: 500 9px/1 \"Poppins\", sans-serif;\n    letter-spacing: 0.1em;\n}\n\n.products-page .products .category-main .MuiButton-containedPrimary {\n    border-color: #b88a44;\n    background: #b88a44;\n    color: #05090d;\n}\n\n.products-page .products .category-main .MuiButton-root:hover {\n    border-color: rgba(184, 138, 68, 0.75);\n    background: rgba(184, 138, 68, 0.12);\n    box-shadow: none;\n}\n\n@media (max-width: 1100px) {\n    .products-page .products .catalog-hero-content-container { padding-inline: 32px; }\n    .products-page .products .top-text { max-width: 480px; }\n}\n@media (max-width: 900px) {\n\n    .products-page .products .category-main { flex-wrap: wrap; }\n}\n\n@media (max-width: 760px) {\n    .products-page .products .catalog-hero-content-container { padding-inline: 16px; }\n    .products-page .products .top-text { max-width: 360px; }\n}\n@media (max-width: 600px) {\n\n    .products-page .products .top-text p { font-size: 40px; }\n\n    .products-page .products .catalog-subtitle {\n        max-width: 310px;\n        font-size: 11px;\n    }\n\n    .products-page .products .single-button-search.MuiButton-root {\n        min-width: 104px;\n        padding-inline: 14px !important;\n    }\n}.sub-category-list {\n    position: absolute;\n    left: calc(50% + 150px);\n    top: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    animation: fadeInRight 0.5s ease;\n}\n\n.sub-category-list button {\n    background: none !important;\n    border: none !important;\n    font-family: 'Playfair Display', serif;\n    font-size: 18px;\n    color: #777 !important;\n    cursor: pointer;\n    text-align: left;\n    padding: 0;\n}\n/* --- PRODUCT CARD & WRAPPER --- */\n/* --- PRODUCT CARD & WRAPPER --- */\n.products-page .products .product-wrapper {\n    margin-left: 25px;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center; /* Centers the cards */\n}\n\n.products-page .products .product-card {\n    margin: 34px 20px;\n    width: 270px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow: hidden;\n    background: #0d1e2b;\n    padding-bottom: 14px;\n    border: 1px solid rgba(184, 138, 68, 0.2);\n    border-radius: 8px;\n    box-shadow: 0 12px 28px rgba(5, 9, 13, 0.12);\n    transition: transform 260ms ease, border-color 260ms ease, box-shadow 260ms ease;\n}\n\n.products-page .products .product-card:hover {\n    transform: translateY(-4px);\n    border-color: rgba(184, 138, 68, 0.42);\n    box-shadow: 0 16px 34px rgba(5, 9, 13, 0.18);\n}\n\n.products-page .products .product-card .product-img {\n    position: relative;\n    width: 273px;\n    height: 275px;\n    background-size: cover;\n    background-position: center;\n    /* Luxury Shape: Sharp top, soft bottom curve */\n    border-radius: 8px 8px 0 0;\n}\n\n.products-page .products .product-card .product-img .product-sale {\n    position: absolute;\n    margin: 15px;\n    z-index: 100;\n    width: auto;\n    min-width: 54px;\n    height: 26px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* Luxury Tag: Champagne Gold with dark text */\n    background: rgba(13, 30, 43, 0.82);\n    box-shadow: none;\n    border-radius: 3px;\n    font-family: \"Poppins\", sans-serif;\n    font-size: 9px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #b88a44; /* Dark blue/black text */\n}\n\n.products-page .products .product-img:before {\n    border-radius: 8px 8px 0 0;\n    content: \"\";\n    opacity: 0;\n    transition: opacity 0.5s ease;\n    position: absolute;\n    top: 0; left: 0; right: 0; bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    z-index: 2;\n}\n\n.products-page .products .product-img:hover:before {\n    opacity: 1;\n}\n\n/* --- HOVER BUTTONS --- */\n.products-page .products .shop-btn {\n    position: absolute;\n    top: 217px; left: 105px;\n    width: 64px; height: 46px;\n    z-index: 3;\n    opacity: 0;\n    transition: opacity 0.5s ease;\n    background: rgba(13, 30, 43, 0.88) !important;\n    border: 2px solid #d7b686 !important;\n    border-radius: 10px !important;\n}\n\n.products-page .products .view-btn {\n    position: absolute;\n    top: 223px; right: 36px;\n    width: 40px; height: 40px;\n    z-index: 3;\n    opacity: 0;\n    transition: opacity 0.5s ease;\n}\n\n.products-page .products .product-img:hover .shop-btn,\n.products-page .products .product-img:hover .view-btn {\n    opacity: 1;\n}\n\n/* --- PRODUCT DESCRIPTION --- */\n.products-page .products .product-card .product-desc {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.products-page .products .product-desc .product-title {\n    margin-top: 12px;\n    font-family: \"Playfair Display\", serif;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 1.2;\n    color: #f4f1ea;\n    letter-spacing: 0.025em;\n    text-transform: capitalize;\n    transition: color 260ms ease;\n}\n\n/* Hover state adds a premium \"Luxury Gold\" glow */\n.products-page .products .product-card:hover .product-title {\n    color: #b88a44;\n}\n.products-page .products .product-desc .product-desc {\n    margin-top: 5px;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 1;\n    color: #b88a44;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n}\n\n.products-page .products .product-desc .product-desc .MuiSvgIcon-root {\n    width: 15px;\n    height: 15px;\n    opacity: 0.72;\n}\n\n/* --- BRANDS & ADDRESS --- */\n/* --- BRANDS SECTION CSS --- */\n/* Container Style */\n.brands-logo {\n  width: 100%;\n  background: #e8e1d7;\n  padding: 80px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.brands-logo .brands-title {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 36px;\n  font-weight: 600;\n  color: #10202b;\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.video-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 30px; /* More space between stands */\n  width: 90%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.video-box {\n  width: 100%;\n  aspect-ratio: 3 / 4; /* Keeps them as \"Luxury Stands\" */\n  overflow: hidden;\n  border-radius: 20px 20px 50px 50px;\n  border: 2px solid #d7b586;\n  background: #1a1e22;\n}\n  \n.video-box video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 15px 15px 40px 40px; /* Matches container shape */\n}\n\n.video-box:hover {\n  transform: translateY(-10px); /* Lift effect */\n  box-shadow: 0 20px 40px rgba(215, 181, 134, 0.3);\n}\n\n.video-box video {\n  width: 100%;.video-box video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* Ensures video stays inside the box */\n}\n  height: 100%;\n  object-fit: cover;\n  border-radius: 15px 15px 40px 40px; /* Matches the container shape */\n}\n/* Responsive Grid for Tablets/Phones */\n\n@media (max-width: 900px) {\n  .video-grid { grid-template-columns: repeat(2, 1fr); }\n}\n\n\n@media (max-width: 600px) {\n  .video-grid { grid-template-columns: 1fr; }\n}\n\n/* Restored Hover Logic */\n/* --- BRANDS SECTION CSS --- */\n.brands-logo .brand-card {\n  width: 200px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  /* Added your border and radius here */\n  border: 1px solid #d9d9d9;\n  border-radius: 10px; \n  /* ------------------------------- */\n  transition: all 0.4s ease; \n  cursor: pointer;\n}\n\n.brands-logo .brand-card:hover {\n  transform: translateY(-5px); \n  box-shadow: 0px 10px 25px rgba(215, 181, 134, 0.2); \n  background: rgba(255, 255, 255, 0.03);\n  /* Optional: Change border color on hover to match the glow */\n  border-color: #d7b586; \n}\n\n.brands-logo .brand-card img {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n/* --- CHOSEN PRODUCT --- */\n.products-page .chosen-product {\n    position: relative;\n    width: 100%;\n    height: auto;\n    background: #f2eee6;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.products-page .chosen-product .product-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-top: 80px;\n    margin-bottom: 150px;\n}\n\n.products-page .chosen-product .chosen-product-slider {\n    width: 48%;\n    height: 480px;\n    background: #ffffff;\n    box-shadow: 9px 13px 14px 5px rgba(0, 0, 0, 0.25), inset -1px 2px 10px 3px rgba(0, 0, 0, 0.25);\n    border-radius: 16px;\n    overflow: hidden;\n}\n\n.products-page .chosen-product .chosen-product-slider .swiper-area {\n    --swiper-navigation-color: #fff;\n    --swiper-pagination-color: #fff;\n    width: 100%;\n    height: 1020px;\n}\n\n.products-page .chosen-product .chosen-product-slider .swiper-area .slider-image {\n    width: 100%;\n    height: 100%;\n}\n\n.products-page .chosen-product .chosen-product-info {\n    padding: 30px 40px;\n    width: 49%;\n    height: 480px;\n    display: flex;\n    background: #ffffff;\n    box-shadow: 9px 13px 14px 5px rgba(0, 0, 0, 0.25), inset -1px 2px 10px 3px rgba(0, 0, 0, 0.25);\n    border-radius: 16px;\n}\n\n.products-page .chosen-product .chosen-product-info .info-box {\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n.products-page .chosen-product .info-box .product-name {\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 36px;\n    color: #000000;\n}\n\n.products-page .chosen-product .info-box .stock-count {\n    margin-top: 16px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 17px;\n    line-height: 15px;\n    color: #979797;\n}\n\n.products-page .chosen-product .info-box .rating-box {\n    margin-top: 20px;\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.products-page .chosen-product .rating-box .star-box {\n    width: auto;\n    height: auto;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.products-page .chosen-product .rating-box .evaluation-box {\n    width: auto;\n    height: auto;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.products-page .chosen-product .rating-box .evaluation-box .product-view {\n    display: flex;\n    align-items: center;\n}\n\n.products-page .chosen-product .info-box .product-desc {\n    height: 112px;\n    margin-top: 30px;\n    margin-bottom: 30px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    color: #000000;\n}\n\n.products-page .chosen-product .info-box .product-price {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.products-page .chosen-product .product-price span {\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 25px;\n    line-height: 22px;\n    color: #000000;\n}\n\n.products-page .chosen-product .button-box {\n    width: 100%;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.products-page .chosen-product .button-box button {\n    width: 230px;\n    height: 44px;\n    font-family: \"Poppins\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 22px;\n    color: #f8f8ff;\n}\n\n.products-page .chosen-product .title {\n    font-family: \"Dancing Script\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 36px;\n    line-height: 43px;\n    margin-top: 40px;\n}\n\n.address {\n  width: 100%;\n  padding: 80px 0;\n  background-color: #f2eee6;\n  display: flex;\n  justify-content: center;\n}\n\n.address-area {\n  width: 100%;\n  align-items: center;\n}\n\n.address-area .title {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 36px;\n  font-weight: 600;\n  color: #10202b;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n/* Luxury Map Wrapper */\n.map-luxury-wrapper {\n  width: 100%;\n  max-width: 1100px; /* Wider for better visibility */\n  height: 500px;     /* Set a clear, tall height */\n  margin: 40px auto;\n  border: 3px solid #d7b586; /* Gold border */\n  border-radius: 20px;\n  padding: 5px;\n  background: #1a1e22;\n  box-shadow: 0 15px 40px rgba(0,0,0,0.7);\n  overflow: hidden;\n}\n\n.map-luxury-wrapper iframe {\n  width: 100%;\n  height: 100%;\n  border-radius: 15px;\n  /* Dark mode filter to match your theme */\n  filter: grayscale(0.5) invert(0.9) contrast(1.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
